<!---->
<template>
  <el-form
    ref="form"
    v-bind="$attrs"
    :inline="inline"
    :label-position="computedLabelPosition"
    :class="[
      'rt-form',
      'is-' + labelColor,
      labelColon ? 'is-label-colon' : '',
      border ? 'is-border-form' : ''
    ]"
    :all-clearable="allClearable"
    @submit.native.prevent
  >
    <slot />
  </el-form>
</template>

<script>
import xpcConfig from '../../config';
import { scrollIntoView } from 'vue-xpc/src/utils/util.js';
const methods = [
  'validateField',
  'resetFields',
  'toggleRowExpansion',
  'clearValidate'
];
export default {
  name: 'RtForm',
  props: {
    // 设置 inline 属性可以让表单域变为行内的表单域
    inline: Boolean,
    labelPosition: String,
    readonly: {
      type: Boolean,
      default: false
    },
    labelColor: {
      type: String,
      default: 'regular'
    },
    labelColon: {
      type: Boolean,
      default: false
    },
    border: {
      type: Boolean,
      default: true
    },
    allClearable: {
      type: Boolean,
      default: true
    },
    autoJumpTo: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    // eslint-disable-next-line vue/return-in-computed-property
    computedLabelPosition () {
      if (this.readonly) {
        return this.labelPosition === 'top' ? 'left' : this.labelPosition;
      } else {
        return this.labelPosition || xpcConfig.get('form.labelPosition');
      }
    }
  },
  mounted () {
    if (this.readonly) {
      this.$el.classList.add('rt-form--readonly');
    }
    this.$nextTick(() => {
      if (!this.$refs.form) return;

      // 将 elementui form 组件原生方法附加在 rtFrom 上面
      methods.forEach(method => {
        this[method] = this.$refs.form[method];
      });
    });
  },
  provide () {
    return { labelPosition: this.labelPosition };
  },
  methods: {
    validate (callback) {
      if (typeof callback === 'function') {
        this.$refs.form.validate((valid, object) => {
          if (!valid) {
            // 如果为可编辑单元格，则不主动跳转到错误为止
            if (!this.autoJumpTo) return;
            this.$nextTick(() => {
              const form = this.$refs.form;
              let targetView =
              form &&
              form.$el &&
              form.$el.getElementsByClassName('is-error') &&
              form.$el.getElementsByClassName('is-error')[0] &&
              form.$el
                .getElementsByClassName('is-error')[0]
                .getElementsByTagName('input') &&
              form.$el
                .getElementsByClassName('is-error')[0]
                .getElementsByTagName('input')[0];
              scrollIntoView(targetView);
            });
          }
          callback && callback(valid, object);
        });
      } else {
        return new Promise((resolve, reject) => {
          this.$refs.form
            .validate()
            .then((...args) => {
              resolve(...args);
            })
            .catch(err => {
              this.$nextTick(() => {
                const form = this.$refs.form;
                let targetView =
              form &&
              form.$el &&
              form.$el.getElementsByClassName('is-error') &&
              form.$el.getElementsByClassName('is-error')[0] &&
              form.$el
                .getElementsByClassName('is-error')[0]
                .getElementsByTagName('input') &&
              form.$el
                .getElementsByClassName('is-error')[0]
                .getElementsByTagName('input')[0];
                scrollIntoView(targetView);

                reject(err);
              });
            });
        });
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// rtForm.vue?105fa6ff